import React from 'react'

import { ZariContext } from '_zari/context'
import { Form, Col, AsyncSelect } from '_zari/core'

import { ClearInputGroup } from 'sharedComponents/utils'

import * as ProductosService from 'services/producto.service'

import { TiposProductoConstant } from 'constants/index'

import { RounderUtil, KeyEventUtil } from 'utils'

const ProductoFormGroup = ({ fIsSubmitting, iError, values, setValues, idListaPrecio }) => {
  const __zariContext = React.useContext(ZariContext)

  const onChange = pickedProducto => {
    ProductosService.getProducto_Ventas(pickedProducto.value, idListaPrecio).then(({ data }) => {
      if (data.flagAnticipo) {
        __zariContext.snack('error', 'Productos anticipos no pueden aplicar en venta grifo.')
        return
      }

      let precioListaPrincipal = data.precios.map(x => {
        return {
          _idProductoPresentacionPrecio: x._id,
          precio: x.precio
        }
      })[0]

      if (data.precios) {
        data.precios = data.precios.map(val => {
          return {
            _id: val._id,
            precio: val.precio,
            precioListaNombre: val.precioListaNombre,
            precioListaPrincipal: val.precioListaPrincipal
          }
        })
      }

      const { _id: _idProductoPresentacion, ...newData } = data

      const salida = {
        incluyeIGV: true,
        _idProductoPresentacion,
        ...precioListaPrincipal,
        ...newData
      }

      values.afectacion = salida.afectacion
      values.codigoProducto = salida.codigoProducto
      values.nombreProducto = salida.nombreProducto
      values.flagBolsa = salida.flagBolsa
      values.incluyeIGV = salida.incluyeIGV
      values.nombreUnidadDeMedida = salida.nombreUnidadDeMedida
      values.precio = salida.precio
      values.precios = salida.precios
      values._idProductoPresentacion = salida._idProductoPresentacion
      values._idProductoPresentacionPrecio = salida._idProductoPresentacionPrecio

      if (values.cantidad) {
        const total = RounderUtil.round(parseFloat(values.cantidad || 0) * (values.precio || 0))
        values.total = total
      } else {
        values.cantidad = 1
        values.total = values.precio
      }

      setValues(values)
      KeyEventUtil.leaveOnKeyEvent('producto-adicional-select-cantidad')
    })
  }

  const clickClear = () => {
    values._idProducto = ''
    values.afectacion = ''
    values.codigoProducto = ''
    values.nombreProducto = ''
    values.flagBolsa = false
    values.incluyeIGV = true
    values.nombreUnidadDeMedida = ''
    values.precio = 0
    values._idProductoPresentacion = ''
    values.total = 0

    setValues(values)
    KeyEventUtil.leaveOnKeyEvent('producto-adicional-select2-producto')
  }

  const loadOptions = (inputValue, resolve) => {
    ProductosService.obtenerAsVentasSelect2({
      busqueda: inputValue,
      tipo: TiposProductoConstant.BIEN
    }).then(({ data }) => resolve(data))
  }

  return (
    <Form.Group>
      <Form.Label text='PRODUCTO' htmlFor='producto-adicional-input-producto' md={4} alignRightAt='md' />
      <Col md={8}>
        {values._idProductoPresentacion ? (
          <ClearInputGroup
            id='producto-adicional-input-producto'
            iValue={`${values.codigoProducto} - ${values.nombreProducto}`}
            clickClear={clickClear}
          />
        ) : (
          <AsyncSelect
            selectId='producto-adicional-select2-producto'
            disabled={fIsSubmitting}
            loadOptions={loadOptions}
            onChange={onChange}
          />
        )}
        {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProductoFormGroup)
